import { IoHome } from "react-icons/io5";
import { BiSolidReport } from "react-icons/bi";
import { FaHotel } from "react-icons/fa";
import { ImUser } from "react-icons/im";
import { FaPersonWalkingLuggage } from "react-icons/fa6";
import { ImExit } from "react-icons/im";
import { ImEnter } from "react-icons/im";
import { FaFileInvoice } from "react-icons/fa6";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { FaCashRegister } from "react-icons/fa";
import { FaMoneyBillWave } from "react-icons/fa";
import { FaFileDownload } from "react-icons/fa";
import { GiNotebook } from "react-icons/gi";
import { FaBook } from "react-icons/fa";
import { GiLoincloth } from "react-icons/gi";
import { GiAutoRepair } from "react-icons/gi";
import { GrUserWorker } from "react-icons/gr";
import { ImBook } from "react-icons/im";
import { MdSearch } from "react-icons/md";
import { MdNotifications } from "react-icons/md";
import { MdReceipt } from "react-icons/md";
import AdminDashboard from './pages/admin/dashboard';
import Hotels from "./pages/admin/hotels";
import HotelDetails from "./pages/admin/hotel-details";
import Rooms from "./pages/admin/rooms";
import Managers from "./pages/admin/managers";
import Reports from "./pages/admin/reports";
import Transactions from "./pages/admin/transactions.js";
import ManagerDashboard from "./pages/manager/dashboard";
import Guests from "./pages/manager/guests";
import CheckIn from "./pages/manager/check-in"
import Checkout from "./pages/manager/check-out";
import Cards from "./pages/manager/cards";
import CardDetails from "./pages/manager/card-details";
import Expense from "./pages/manager/expenses";
import AddExpense from "./pages/manager/add-expense";
import CashTracker from "./pages/manager/cash-tracker";
import EditExpense from "./pages/manager/edit-expense";
import Downloads from "./pages/admin/downloads";
import TaxInvoices from "./pages/manager/tax-invoices";
import Attendance from "./pages/manager/attendance";
import Register from "./pages/manager/register";
import Laundry from "./pages/manager/laundry";
import LaundryItems from "./pages/manager/laundry-items";
import AddLaundry from "./pages/manager/add-laundry";
import EditLaundry from "./pages/manager/edit-laundry";
import ReturnLaundry from "./pages/manager/return-laundry";
import Complaints from "./pages/manager/complaints";
import Employees from "./pages/admin/employees";
import AdvanceBookingsDay from "./pages/manager/advance-bookings-day";
import CreateBooking from './pages/manager/create-booking';
import AdvancedBookingsMonth from "./pages/manager/advanced-bookings-month";
import EditBooking from "./pages/manager/edit-booking";
import Search from "./pages/admin/search";
import ViewCard from './pages/manager/view-card';
import ActivityTracker from "./pages/manager/activity_tracker";
import OTFTaxInvoices from "./pages/admin/otf-tax-invoices";
import AddOTFTaxInvoice from "./pages/admin/add-otf-tax-invoice";
import ViewOTFTaxInvoice from "./pages/admin/view-otf-tax-invoice";
import EditOTFTaxInvoice from "./pages/admin/edit-otf-tax-invoice";
import Notifications from "./pages/admin/notifications";
import Receipts from "./pages/admin/receipts.js";
import AddReceipt from "./pages/admin/add-receipt.js";
import ViewReceipt from "./pages/admin/view-receipt.js";
import EditReceipt from "./pages/admin/edit-receipt.js";

const icon = {
    className: "w-5 h-5 text-inherit",
};

const routes = [
    {
        title: "Administrator",
        layout: "admin",
        role: "ADMIN",
        pages: [
            {
                icon: <IoHome {...icon} />,
                name: "Dashboard",
                path: "/dashboard",
                element: <AdminDashboard />,
                isNavLink: true
            },
            {
                icon: <FaHotel {...icon} />,
                name: "Hotels",
                path: "/hotels",
                element: <Hotels />,
                isNavLink: true
            },
            {
                icon: <FaHotel {...icon} />,
                name: "Hotels",
                path: "/hotels/:hotelId",
                element: <HotelDetails />,
                isNavLink: false
            },
            {
                icon: <MdNotifications  {...icon} />,
                name: "Notifications",
                path: "/notifications",
                element: <Notifications />,
                isNavLink: true
            },
            {
                icon: <BiSolidReport {...icon} />,
                name: "Reports",
                path: "/reports",
                element: <Reports />,
                isNavLink: false
            },
            {
                icon: <FaIndianRupeeSign {...icon} />,
                name: "Transactions",
                path: "/transactions",
                element: <Transactions />,
                isNavLink: true
            },
            {
                icon: <FaFileDownload {...icon} />,
                name: "Downloads",
                path: "/downloads",
                element: <Downloads />,
                isNavLink: true
            },
            {
                icon: <ImUser {...icon} />,
                name: "Managers",
                path: "/managers",
                element: <Managers />,
                isNavLink: false
            },
            {
                icon: <FaHotel {...icon} />,
                name: "Rooms",
                path: "/hotels/:hotelId/rooms",
                element: <Rooms />,
                isNavLink: false
            },
            {
                icon: <GrUserWorker  {...icon} />,
                name: "Employees",
                path: "/employees",
                element: <Employees />,
                isNavLink: true
            },
            {
                icon: <MdSearch {...icon} />,
                name: "Search",
                path: "/search",
                element: <Search />,
                isNavLink: true
            },
            {
                icon: <FaBook {...icon} />,
                name: "OTF Invoices",
                path: "/otf-tax-invoices",
                element: <OTFTaxInvoices />,
                isNavLink: true
            },
            {
                icon: <FaBook {...icon} />,
                name: "OTF Invoices",
                path: "/otf-tax-invoices/create",
                element: <AddOTFTaxInvoice />,
                isNavLink: false
            },
            {
                icon: <FaBook {...icon} />,
                name: "OTF Invoices",
                path: "/otf-tax-invoices/view/:invoiceNo",
                element: <ViewOTFTaxInvoice />,
                isNavLink: false
            },
            {
                icon: <FaBook {...icon} />,
                name: "OTF Invoices",
                path: "/otf-tax-invoices/edit/:invoiceNo",
                element: <EditOTFTaxInvoice />,
                isNavLink: false
            },
            {
                icon: <MdReceipt {...icon} />,
                name: "Receipts",
                path: "/receipts",
                element: <Receipts />,
                isNavLink: true
            },
            {
                icon: <MdReceipt {...icon} />,
                name: "Receipts",
                path: "/receipts/create",
                element: <AddReceipt />,
                isNavLink: false
            },
            {
                icon: <MdReceipt {...icon} />,
                name: "Receipts",
                path: "/receipts/view/:receiptNo",
                element: <ViewReceipt />,
                isNavLink: false
            },
            {
                icon: <MdReceipt {...icon} />,
                name: "Receipts",
                path: "/receipts/edit/:receiptNo",
                element: <EditReceipt />,
                isNavLink: false
            },
        ]
    },
    {
        title: "Manager",
        layout: "manager",
        role: "MANAGER",
        pages: [
            {
                icon: <IoHome {...icon} />,
                name: "Dashboard",
                path: "/dashboard",
                element: <ManagerDashboard />,
                isNavLink: true
            },
            {
                icon: <IoHome {...icon} />,
                name: "Activity",
                path: "/dashboard/activity",
                element: <ActivityTracker />,
                isNavLink: false
            },
            {
                icon: <FaPersonWalkingLuggage {...icon} />,
                name: "Add Guest",
                path: "/guest",
                element: <Guests />,
                isNavLink: true
            },
            {
                icon: <ImEnter {...icon} />,
                name: "Check In",
                path: "/checkin",
                element: <CheckIn />,
                isNavLink: true
            },
            {
                icon: <ImExit {...icon} />,
                name: "Check Out",
                path: "/checkout",
                element: <Checkout />,
                isNavLink: true
            },
            {
                icon: <FaFileInvoice {...icon} />,
                name: "Cards",
                path: "/cards",
                element: <Cards />,
                isNavLink: true
            },
            {
                icon: <FaFileInvoice {...icon} />,
                name: "Cards",
                path: "/cards/:cardNo",
                element: <ViewCard />,
                isNavLink: false
            },
            {
                icon: <FaFileInvoice {...icon} />,
                name: "Cards",
                path: "/cards/:cardNo/print",
                element: <CardDetails />,
                isNavLink: false
            },
            {
                icon: <FaBook {...icon} />,
                name: "Invoices",
                path: "/tax-invoices",
                element: <TaxInvoices />,
                isNavLink: true
            },
            {
                icon: <FaCashRegister {...icon} />,
                name: "Expenses",
                path: "/expenses",
                element: <Expense />,
                isNavLink: true
            },
            {
                icon: <FaCashRegister {...icon} />,
                name: "Expenses",
                path: "/expenses/add",
                element: <AddExpense />,
                isNavLink: false
            },
            {
                icon: <FaCashRegister {...icon} />,
                name: "Expenses",
                path: "/expenses/edit",
                element: <EditExpense />,
                isNavLink: false
            },
            {
                icon: <FaMoneyBillWave {...icon} />,
                name: "Cash Tracker",
                path: "/tracker",
                element: <CashTracker />,
                isNavLink: true
            },
            {
                icon: <GiAutoRepair {...icon} />,
                name: "Complaints",
                path: "/complaints",
                element: <Complaints />,
                isNavLink: false
            },
            {
                icon: <GiNotebook {...icon} />,
                name: "Attendance",
                path: "/attendance",
                element: <Attendance />,
                isNavLink: true
            },
            {
                icon: <GiNotebook {...icon} />,
                name: "Attendance",
                path: "/attendance/register/:selectedMonth",
                element: <Register />,
                isNavLink: false
            },
            {
                icon: <GiLoincloth {...icon} />,
                name: "Laundry",
                path: "/laundry",
                element: <Laundry />,
                isNavLink: true
            },
            {
                icon: <GiLoincloth {...icon} />,
                name: "Laundry",
                path: "/laundry-items",
                element: <LaundryItems />,
                isNavLink: false
            },
            {
                icon: <GiLoincloth {...icon} />,
                name: "Laundry",
                path: "/laundry/create",
                element: <AddLaundry />,
                isNavLink: false
            },
            {
                icon: <GiLoincloth {...icon} />,
                name: "Laundry",
                path: "/laundry/:basketId/edit",
                element: <EditLaundry />,
                isNavLink: false
            },
            {
                icon: <GiLoincloth {...icon} />,
                name: "Laundry",
                path: "/laundry/:basketId/return",
                element: <ReturnLaundry />,
                isNavLink: false
            },
            {
                icon: <ImBook {...icon} />,
                name: "Bookings",
                path: "/bookings",
                element: <AdvancedBookingsMonth />,
                isNavLink: true
            },
            {
                icon: <ImBook {...icon} />,
                name: "Bookings",
                path: "/bookings/:selectedDate",
                element: <AdvanceBookingsDay />,
                isNavLink: false
            },
            {
                icon: <ImBook {...icon} />,
                name: "Bookings",
                path: "/bookings/create",
                element: <CreateBooking />,
                isNavLink: false
            },
            {
                icon: <ImBook {...icon} />,
                name: "Bookings",
                path: "/bookings/edit/:guestMobile/:bookingId/:bookingStatus",
                element: <EditBooking />,
                isNavLink: false
            }
        ]
    },
    {
        title: "Laundry Manager",
        layout: "laundry-manager",
        role: "LAUNDRY_MANAGER",
        pages: [

            {
                icon: <GiLoincloth {...icon} />,
                name: "Laundry",
                path: "/laundry",
                element: <Laundry />,
                isNavLink: true
            },
            {
                icon: <GiLoincloth {...icon} />,
                name: "Laundry",
                path: "/laundry/create",
                element: <AddLaundry />,
                isNavLink: false
            },
            {
                icon: <GiLoincloth {...icon} />,
                name: "Laundry",
                path: "/laundry/:basketId/edit",
                element: <EditLaundry />,
                isNavLink: false
            },
            {
                icon: <GiLoincloth {...icon} />,
                name: "Laundry",
                path: "/laundry/:basketId/return",
                element: <ReturnLaundry />,
                isNavLink: false
            }
        ]
    }
];

export default routes;